<template>
	<div id="sticky-header" class="header">
		<div class="container-landing">
			<div class="header__content">
				<router-link to="/" class="logo-block" v-if="this.$route.name !== 'home'">
					<Logo/>
				</router-link>
				<div class="logo-block" data-index="0" v-on:click="linkClick" v-else>
					<Logo/>
				</div>
				<nav v-if="$route.name === 'home'" class="header__nav" ref="headerMenu">
					<a :href="item.url" class="header__nav-item" v-for="(item) in links" :key="item.index" :data-index="item.index" v-bind:class='{"is-active": link === item.index}' v-on:click="linkClick"><span>{{ item.name }}</span></a>
					<router-link to="/addDocument" class="header__nav-item"><span>{{ $lib.translate('Добавить дело') }}</span></router-link>
				</nav>
				<a href="//admin.impartiality.online/" class="button-landing button-landing--defalt">вход</a>
				<div class="burger-menu" v-on:click="toggleMenu" ref="buttonBurger"></div>
			</div>
		</div>
	</div>
</template>

<script>
import Logo from '../components/Logo.vue';

export default {
	name: 'Header',

	data: function () {
		return {
			body: document.body,
			header: null,
			links: [
				{name: this.$lib.translate('Определение'), url: '#definition', index: 1},
				{name: this.$lib.translate('Миссия'), url: '#mission', index: 2},
				{name: this.$lib.translate('Цели'), url: '#purposes', index: 3},
				{name: this.$lib.translate('Статистика'), url: '#statistics', index: 4}
			]
		}
	},

	computed: {
		link () {
			return this.$store.getters.GET_ACTIVE_LINK;
		}
	},

	components: {
		Logo
	},

	methods: {
		toggleMenu () {
			this.$refs.buttonBurger.classList.toggle('is-open');
			this.$refs.headerMenu.classList.toggle('is-open');
		},
		documentClick (event) {
			const stickyHeader = document.getElementById('sticky-header');
			if (this.$refs.buttonBurger.classList.contains('is-open') && stickyHeader && !stickyHeader.contains(event.target)) {
				this.toggleMenu();
			}
		},
		goToBlock (href) {
			const block = this.body.querySelector(href);
			if (block) {
				const top = block.offsetTop - this.header.offsetHeight;
				this.$lib.scrollTo(top);
			} else {
				this.$lib.scrollTo(0);
			}
		},
		linkClick (event) {
			event.preventDefault();
			const element = event.currentTarget;
			const href = element.getAttribute('href');
			const index = parseInt(element.getAttribute('data-index'));
			this.goToBlock(href);
			this.$store.dispatch('SET_ACTIVE_LINK', index);
			if (index !== 0) {
				history.pushState({}, '', this.links.filter((item) => item.index === index)[0].url);
			} else {
				history.pushState({}, '', '/');
			}
		}
	},

	mounted: function () {
		this.header = document.getElementById('sticky-header');
		document.addEventListener('click', this.documentClick);
		if (location.hash) {
			this.goToBlock(location.hash);
		}
	},

	beforeDestroy: function () {
		document.removeEventListener('click', this.documentClick);
	}
}
</script>
